import { Select, MenuItem, FormControl, InputLabel, Button, Box, Typography, Divider } from "@mui/material";
import { ROLES } from "../../../utils/constants";
import { UserFromAPI } from "../../../types/auth.types";

type SchedulesUserFilterProps = {
    users: Array<any>;
    userIds: Array<string>;
    setUserIds: (userId: Array<string>) => void;
};

export const SchedulesUserFilter = ({ users = [], userIds, setUserIds }: SchedulesUserFilterProps) => {
    return (
        <FormControl fullWidth>
            <InputLabel>Colaborador(a)</InputLabel>
            <Select
                multiple
                value={userIds}
                onChange={(e) => {
                    const value = e.target.value as Array<string>;
                    const processedUserIds = processUserSelection(value, users);
                    setUserIds(processedUserIds);
                }}
                label="Colaborador(a)"
                renderValue={(selected) =>
                    users
                        .filter((user) => selected.includes(user.id))
                        .map((user) => `${user.first_name} ${user.last_name}`)
                        .join(", ")
                }
            >
                <MenuItem sx={{ paddingY: 2 }} value="__clear__">
                    Remover
                </MenuItem>

                {users.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                        <SelectOption user={user} setUserIds={setUserIds} />
                    </MenuItem>
                ))}
                <Divider />

                <MenuItem value="neurofeedback_team">
                    <Button fullWidth variant="contained" color="secondary">
                        Relacionado com Neurofeedback
                    </Button>
                </MenuItem>
                <MenuItem value="psychology_team">
                    <Button fullWidth variant="contained" color="secondary">
                        Relacionado com Psicologia
                    </Button>
                </MenuItem>
                <MenuItem value="customer_support_team">
                    <Button fullWidth variant="contained" color="secondary">
                        Apoio ao cliente
                    </Button>
                </MenuItem>
                <MenuItem value="other_team">
                    <Button fullWidth variant="contained" color="secondary">
                        Outros
                    </Button>
                </MenuItem>
            </Select>
        </FormControl>
    );
};

type SelectOptionType = {
    user: any;
    setUserIds: (userId: Array<string>) => void;
};

const SelectOption = ({ user, setUserIds }: SelectOptionType) => {
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" flex={1}>
            <Typography variant="body1">
                {user.first_name} {user.last_name}
            </Typography>

            <Button
                size="small"
                onClick={(e) => {
                    e.stopPropagation();
                    setUserIds([user.id]);
                }}
            >
                Só
            </Button>
        </Box>
    );
};

const processUserSelection = (selectedValues: Array<string>, users: Array<UserFromAPI>) => {
    if (selectedValues.includes("__clear__")) {
        return [];
    }

    const teamMappings = {
        neurofeedback_team: "neurofeedback",
        psychology_team: "psicologia",
        customer_support_team: "customer_support",
        other_team: "other",
    };

    const teamValue = selectedValues.find((value) => value in teamMappings);
    if (teamValue) {
        const specialization = teamMappings[teamValue as keyof typeof teamMappings];
        return users
            .filter((user) => {
                const technicianSpecializations = user.technician_id?.[0]?.specializations || [];
                if (specialization === "customer_support") {
                    return (
                        user.role.id === ROLES.recepcionist ||
                        user.role.id === ROLES.reception_director ||
                        user.role.id === ROLES.callcenter ||
                        user.role.id === ROLES.back_office
                    );
                }
                if (specialization === "other") {
                    return technicianSpecializations.length === 0;
                }
                return technicianSpecializations.includes(specialization);
            })
            .map((user) => user.id);
    }

    return selectedValues;
};
